import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import * as R from 'ramda';

import {
  DataBlocks,
  I18n,
  Link,
  ErrorBlock,
  Status,
  Button,
  Preloader,
  AppButton,
} from 'components';
import declint from 'utils/declint';

import { priceProcessing } from 'utils/formatPrice';
import { fetchData } from './actions';
import { fetchData as fetchUserInfo } from '../Home/actions';
import Service from './components/Service';
import Device from './components/Device';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

class TV extends Component {
  constructor(props) {
    super(props);
    this.state = {
      periodStr: props.pricePeriod || 'в месяц',
    };
  }

  componentDidMount() {
    const { actions, isConvergent, pricePeriod } = this.props;
    actions.fetchData();
    if (isConvergent && !pricePeriod) {
      actions.fetchUserInfo(['Convergence']);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pricePeriod !== this.props.pricePeriod) {
      this.setState({
        periodStr: this.props.pricePeriod,
      });
    }
  }

  getFullPrice = () => {
    const { connectedTariff, devices, multiRoom } = this.props;
    let price = 0;

    if (connectedTariff && connectedTariff.groups) {
      const { tvPackets, subscriptions, services } = connectedTariff.groups;
      const groups = [tvPackets, subscriptions, services];

      price += groups.reduce((value, group) => (
        value + group.reduce((subgroupsValue, subgroup) => (
          subgroupsValue + subgroup.packets.reduce((packetsValue, packet) => (
            packetsValue + packet.price
          ), 0)
        ), 0)
      ), connectedTariff.price);
    }

    if (multiRoom) {
      price += multiRoom.price;
    }

    if (devices && devices.list) {
      price += devices.list.reduce((value, device) => value + (device.price || 0), 0);
    }

    return priceProcessing(price);
  }

  render() {
    const {
      isFetching,
      error,
      actions,
      connectedTariff,
      availableTariff,
      preset,
      multiRoom,
      devices,
      finInfo,
      pricePeriod,
    } = this.props;

    const { periodStr } = this.state;

    if (isFetching) {
      return <Preloader size="80" />;
    }

    if (error) {
      return (
        <ErrorBlock
          title={<I18n path="tv.tv.blockTitle" />}
          refreshAction={actions.fetchData}
        />
      );
    }

    const fullPrice = this.getFullPrice();
    const tvPackets = R.path(['groups', 'tvPackets'], connectedTariff) || [];
    const subscriptions = R.path(['groups', 'subscriptions'], connectedTariff) || [];
    const services = R.path(['groups', 'services'], connectedTariff) || [];

    const isTve = (connectedTariff && connectedTariff.isTve)
      || (devices && devices.list && devices.list[0] && devices.list[0].isTve);

    if (devices && !isTve) {
      devices.deviceLimit = 4;
    }

    return (
      <DataBlocks.Container className={cx('page')}>
        {connectedTariff && (
          <DataBlocks.Block
            title={<I18n path="tv.tv.blockTitle" />}
            info={fullPrice > 0 && (
              <span className={cx('price')}>
                {fullPrice}
                {' '}
                ₽
                {' '}
                {periodStr}
              </span>
            )}
          >
            <div>
              <Service
                type="Тариф"
                ratePeriod={pricePeriod}
                {...connectedTariff}
                preset={preset}
                isBlocked={!finInfo.active}
                isBase
              />
            </div>

            {!finInfo.active && (
              <Status className={[cx('error'), 'error']} emoji="statusFail">
                Договор заблокирован.
                {' '}
                Подключение и изменение услуг невозможно.
                {' '}
                Подробную информацию вы можете узнать на профиле.
              </Status>
            )}

            {availableTariff && (
              <div className={cx('buttonContainer')}>
                <Button
                  className="default"
                  href={`${availableTariff.link}?group=tv`}
                >
                  Изменить тариф
                </Button>
              </div>
            )}
          </DataBlocks.Block>
        )}

        {!connectedTariff && availableTariff && (
          <DataBlocks.Block
            title={<I18n path="tv.tv.blockTitle" />}
            info={fullPrice > 0 && (
              <span className={cx('price')}>
                {fullPrice}
                {' '}
                ₽
                {' '}
                {periodStr}
              </span>
            )}
          >
            <div className={cx('noTV')}>
              <div className={cx('connectLink')}>
                <Link href={availableTariff.link}>
                  <I18n path="tv.tv.connect" />
                </Link>
              </div>
              <I18n
                path="tv.tv.connectInfo"
                vars={{
                  price: availableTariff.price,
                  count: declint(availableTariff.channelCount, ['%s канал', '%s канала', '%s каналов']),
                }}
              />
            </div>
          </DataBlocks.Block>
        )}

        {!connectedTariff && !availableTariff && preset && (
          <DataBlocks.Block
            title={<I18n path="tv.tv.blockTitle" />}
            info={fullPrice > 0 && (
              <span className={cx('price')}>
                {fullPrice}
                {' '}
                ₽
                {' '}
                {periodStr}
              </span>
            )}
          >
            <div className={cx('presetLink')}>
              <Link href={`${preset.link}?group=tv`}>
                Посмотреть данные о тарифе
              </Link>
            </div>
          </DataBlocks.Block>
        )}

        {(tvPackets.length > 0 || connectedTariff) && (
          <DataBlocks.Block
            title={<I18n path="tv.packages.blockTitle" />}
          >
            {tvPackets.map((group) => (
              group.packets.map((packet) => (
                <Service
                  key={packet.packetId}
                  type={group.name}
                  preset={preset}
                  serviceId={connectedTariff.serviceId}
                  splId={connectedTariff.splId}
                  isBlocked={!finInfo.active}
                  ratePeriod={pricePeriod}
                  {...packet}
                />
              ))
            ))}

            {connectedTariff.isChangePacketsAvailable && (
              <div className={cx('buttonContainer')}>
                <Button className="default" href={`${preset.link}?group=tv`}>
                  Подключить
                  {tvPackets.length > 0 ? ' ещё ' : ' '}
                  пакеты
                </Button>
              </div>
            )}
          </DataBlocks.Block>
        )}

        {(subscriptions.length > 0 || connectedTariff) && (
          <DataBlocks.Block
            title={<I18n path="tv.subscriptions.blockTitle" />}
          >
            {subscriptions.map((group) => (
              group.packets.map((packet) => (
                <Service
                  key={packet.packetId}
                  type={group.name}
                  preset={preset}
                  serviceId={connectedTariff.serviceId}
                  splId={connectedTariff.splId}
                  isBlocked={!finInfo.active}
                  ratePeriod={pricePeriod}
                  {...packet}
                />
              ))
            ))}

            {connectedTariff.isChangePacketsAvailable && (
              <div className={cx('buttonContainer')}>
                <Button className="default" href={`${preset.link}?group=tv`}>
                  Подключить
                  {subscriptions.length > 0 ? ' ещё ' : ' '}
                  подписки
                </Button>
              </div>
            )}
          </DataBlocks.Block>
        )}

        {(services.length > 0 || multiRoom) && (
          <DataBlocks.Block
            title={<I18n path="tv.services.blockTitle" />}
          >
            {multiRoom && (
              <Service
                name="Мультирум"
                ratePeriod={pricePeriod}
                {...multiRoom}
                devices={multiRoom.count}
                isRemovable={false}
                isMultiroom
              />
            )}

            {services.map((group) => (
              group.packets.map((service) => (
                <Service
                  key={service.name}
                  type={group.name}
                  preset={preset}
                  serviceId={connectedTariff.serviceId}
                  splId={connectedTariff.splId}
                  isBlocked={!finInfo.active}
                  ratePeriod={pricePeriod}
                  {...service}
                />
              ))
            ))}
          </DataBlocks.Block>
        )}

        {devices && (
          <DataBlocks.Block
            title={(
              <I18n
                path="tv.devices.blockTitle"
                vars={{
                  count: devices && devices.deviceLimit
                    ? `(${devices.list ? devices.list.length : 0} из ${devices.deviceLimit})`
                    : null,
                }}
              />
            )}
          >
            {devices && devices.list && (
              devices.list.map((device, index) => (
                <Device
                  key={device.guid}
                  {...device}
                  multiroom={device.multiroom ? ({
                    ...device.multiroom,
                    link: multiRoom.link,
                    preset,
                  }) : undefined}
                  isBlocked={!finInfo.active}
                  ratePeriod={pricePeriod}
                  isMain={index === 0}
                />
              ))
            )}

            {
              devices && devices.deviceLimit > 0
              && (!devices.list || devices.list.length < devices.deviceLimit) && (
                <div className={cx('newDevicesBanner')}>
                  {devices.list ? (
                    <Button
                      className="default"
                      href={`${preset.link}?group=tv#devices`}
                    >
                      Подключить ещё ТВ-приставку
                    </Button>
                  ) : (
                    <Link href={`${preset.link}?group=tv#devices`}>
                      Заказать приставку для Домашнего ТВ
                    </Link>
                  )}
                  {isTve && (
                    <>
                      <div className={cx('newDevicesBannerText')}>
                        {!devices.list && (
                          <>
                            Смотрите любимые фильмы и сериалы через телефон,
                            {' '}
                            планшет или ТВ-приставку
                            <br />
                          </>
                        )}
                        Чтобы подключить планшет или телефон, скачайте приложение
                        <br />
                        и авторизуйтесь под своим аккаунтом
                      </div>
                      <div className={cx('newDevicesBannerButtons')}>
                        <AppButton
                          className={['googlePlay', cx('appButton')]}
                          href="https://play.google.com/store/apps/details?id=ru.beeline.tve.android"
                        />
                      </div>
                    </>
                  )}
                </div>
              )
            }
          </DataBlocks.Block>
        )}
      </DataBlocks.Container>
    );
  }
}

function mapStateToProps({ tv, home, application }) {
  return {
    ...tv,
    isConvergent: application?.isConvergent,
    pricePeriod: home?.convergence?.data?.pricePeriod,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      fetchData,
      fetchUserInfo,
    }, dispatch),
  };
}

TV.propTypes = {
  connectedTariff: PropTypes.object,
  availableTariff: PropTypes.object,
  preset: PropTypes.object,
  multiRoom: PropTypes.object,
  devices: PropTypes.object,
  finInfo: PropTypes.object,
  actions: PropTypes.object,
  error: PropTypes.any,
  pricePeriod: PropTypes.string,
  isFetching: PropTypes.bool,
  isConvergent: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(TV);
